import { sources } from '@gennetay/chart-core/sources';

export interface PlaceHit {
  name: string;
  lat: number;
  lon: number;
  detail?: string;
}

interface GeocodeReply {
  ok?: unknown;
  data?: unknown;
}

const isPlace = (value: unknown): value is PlaceHit => {
  if (!value || typeof value !== 'object') return false;
  const place = value as Record<string, unknown>;
  return (
    typeof place.name === 'string' &&
    Number.isFinite(place.lat) &&
    Number.isFinite(place.lon) &&
    (place.detail === undefined || typeof place.detail === 'string')
  );
};

export async function geocode(q: string, signal: AbortSignal): Promise<PlaceHit[]> {
  const requestSignal = AbortSignal.any([signal, AbortSignal.timeout(20_000)]);
  const response = await sources().fetch('feeds', `geocode?q=${encodeURIComponent(q)}`, {
    signal: requestSignal
  });
  if (!response.ok) throw new Error(`place search answered ${response.status}`);
  const reply = (await response.json()) as GeocodeReply;
  if (reply.ok !== true || !Array.isArray(reply.data) || !reply.data.every(isPlace)) {
    throw new Error('place search sent an invalid response');
  }
  return reply.data;
}
